// prettier-ignore
export default {
    "100": "Comment",
    "110": "Email",
    "120": "Grafica",
    "140": "Outfolder"
}